module.exports = __webpack_public_path__ + "static/media/record-status-complete.842ea21f.svg";